import { ContentContext } from "../../../../../utils/contexts";

const moment = window.moment;
import {
  Link,
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
  Divider,
  Chip,
  Button,
 } from "@mui/material";
import {  Star, StarBorder, Chat, Gavel, PlaylistAddCheck, FileCopy  } from "@mui/icons-material";
import { savePreferences } from "../../../../../actions";

class Folder extends React.PureComponent {

  onClickSelect = (event) => {
    const { item } = this.props;
    const { onItemSelect } = this.context;

    !item.disabled && event.target.nodeName !== "A" && onItemSelect(item);
  };

  onClickGoIn = async event => {
    event.preventDefault();

    const {
      item: { nodeRef },
      treeItems,
    } = this.props;

    const { fetchContent, fetchTreeChildren, breadcrumbs, fetchBreadcrumbs } = this.context;

    const isCurrent = nodeRef === breadcrumbs[breadcrumbs.length - 1]?.nodeRef;

    if (isCurrent) {
      this.setState(state => ({ open: !state.open }));
    } else {
      await fetchContent(undefined, nodeRef, 1);
      fetchBreadcrumbs(nodeRef);

      // if (!Boolean(treeItems[nodeRef])) {
      //   await fetchTreeChildren(nodeRef);
      // }

      this.setState(() => ({ open: true }));
    }
  };

  addToFavourites = async () => {
    const { item: { nodeRef } } = this.props;
    const { favouriteFolders, fetchPreferences } = this.context;

    const newFavourites = {
      ...favouriteFolders,
      [nodeRef]: nodeRef,
    };

    await savePreferences({
      ["org.alfresco.share.folders.favourites"]: Object.keys(newFavourites).join(','),
    });

    fetchPreferences();
  };

  removeFromFavourites = async () => {
    const { item: { nodeRef } } = this.props;
    const { favouriteFolders, fetchPreferences } = this.context;

    const newFavourites = {
      ...favouriteFolders,
    };

    delete newFavourites[nodeRef];

		await savePreferences({
			["org.alfresco.share.folders.favourites"]: Object.keys(newFavourites).join(','),
		});

    fetchPreferences();
  };

  onCopyLink = niceURL => {
    const root = document.getElementById("path-picker-body");

    if (root) {
      const link = `${window.location.origin}/share/page/browse/${niceURL}`;

      const textArea = document.createElement('textarea');

      textArea.value = link;
      textArea.textContent = link;

      root.appendChild(textArea);

      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
      } catch (err) {
        console.log(err);
      }

      root.removeChild(textArea);
    }
  };

	render() {
		const {
			item: { nodeRef, properties, name, indicators, disabled, path },
			index,
		} = this.props;

		const { selected, hidden, loadingContent, favouriteFolders, currentSite, searchQuery, switchValue } = this.context;

		const isSelected = Boolean(selected[nodeRef]);
		const isHidden = Boolean(hidden[nodeRef]);
		const isInFavourites = favouriteFolders[nodeRef];

		const niceURL = properties['niceURL:niceURL'];

		const currentDay = moment();
		const modifiedDate = moment(properties['cm:modified'].iso8601);
		const hourDifference = currentDay.diff(modifiedDate, 'seconds') / 60 / 60;
		let time = '';
		const isOneDay = hourDifference > 24 && hourDifference < 47;

		if (hourDifference > 24) {
			time = isOneDay
				? window.Alfresco.messages.global['relative.day']
				: Math.round(hourDifference / 24) + ` ${window.Alfresco.messages.global['date-unit.plural.day']}`;
		} else {
			time = hourDifference > 1
				? Math.round(hourDifference) + ` ${window.Alfresco.messages.global['date-unit.plural.hour']}`
				: Math.round(hourDifference * 60) + ` ${window.Alfresco.messages.global['date-unit.plural.minute']}`;
		}

		const hasMetafill = indicators.find(indicator => indicator.id === 'metafill');
		const hasRules = indicators.find(indicator => indicator.id === 'rules');

		return (
			<>
				<ListItem
					button
					disableRipple
					disableTouchRipple
					onClick={(event) => this.onClickSelect(event)}
					selected={isSelected}
					disabled={disabled || isHidden || loadingContent}
					id={`docLibItem${index}`}
					sx={{
						pl: 2,
						pt: 0,
						pb: 0,
						opacity: 1,
						'&.Mui-selected': { backgroundColor: 'rgba(0, 0, 0, 0.08)' }
					}}
				>
					<ListItemAvatar
						sx={{
							fontSize: '22px',
							minWidth: '37px',
							mr: '10px',
							color: '#e3c305',
							textAlign: "center",
							'& .green': {
								color: 'green',
							},
							'& .red': {
								color: 'red',
							},
							'& .blue': {
								color: '#0e1f3e',
							},
						}}
					>
						<div style={{ minWidth: "23px", textAlign: "center" }}>
							<i className={`fas fa-${isSelected ? 'check-circle blue' : 'folder '}${disabled ? ' red' : ''}`} />
						</div>
					</ListItemAvatar>
					<ListItemText
						primary={
							currentSite.nodeRef === '' ? name : (
								<Link
									href="#"
									onClick={this.onClickGoIn}
									sx={{
										fontSize: '13px',
										pointerEvents: 'auto',
										'&:hover': {
											color: '#0c79bf !important',
										},
									}}
								>
									{`${name}${window.Edocat?.Config?.showTitle && properties['cm:title'] ? ` (${properties['cm:title']})` : ''}`}
								</Link>
							)
						}
						secondary={
							((currentSite.nodeRef !== '' && searchQuery !== '' && switchValue) || (currentSite.nodeRef === ''))
								? `${path}`
								: `${window.Alfresco.messages.global[isOneDay ? 'prop.cm_modified.title' : 'edocat.document-library.edited']} ${time} ${properties['cm:modifier'].displayName}`
						}
						sx={{
							fontSize: '13px',
							maxWidth: '50%',
							wordBreak: 'break-all',
						}}
					/>
					<ListItemSecondaryAction
						sx={{
							display: 'flex',
							flexWrap: 'wrap',
							alignItems: 'center',
						}}
					>
						{niceURL && (
							<Tooltip title={window.Alfresco.messages.global['edocat.document-actions.copy-link-folder']}>
								<Button
									variant="contained"
									disableElevation
									endIcon={<FileCopy fontSize="small" />}
									onClick={() => this.onCopyLink(niceURL)}
									id={`docLibItem${index}CopyLinkBtn`}
									disabled={loadingContent}
									sx={{
										borderRadius: '16px',
										backgroundColor: '#e0e0e0',
										color: 'rgba(0, 0, 0, 0.87)',
										fontSize: '13px',
									}}
								>
									{niceURL}
								</Button>
							</Tooltip>
						)}
						{properties['cm:taggable'] && (
							<div style={{ display: 'inline-flex', flexWrap: 'wrap' }}>
								{properties['cm:taggable'].map(tag => (
									<Chip key={tag.name} label={tag.name} sx={{ m: '0 5px 0 0', p: '5px' }} />
								))}
							</div>
						)}
						{Boolean(parseInt(properties['fm:commentCount'])) && (
							<div style={{ display: 'inline-flex', flexWrap: 'wrap' }}>
								<Chip>
									<Chat fontSize="small" />
									{properties['fm:commentCount']}
								</Chip>
							</div>
						)}
						{hasMetafill && (
							<Tooltip title={window.Alfresco.messages.global['edocat.document-library.indicator.metafill']}>
								<Chip label={<PlaylistAddCheck fontSize="small" />} sx={{ px: '3px' }} />
							</Tooltip>
						)}
						{hasRules && (
							<Tooltip title={window.Alfresco.messages.global['edocat.document-library.indicator.rules']}>
								<Chip label={<Gavel fontSize="small" />} sx={{ px: '3px' }} />
							</Tooltip>
						)}
						<Tooltip
							title={
								isInFavourites
									? window.Alfresco.messages.global['favourite.folder.remove.tip']
									: window.Alfresco.messages.global['favourite.folder.add.tip']
							}
						>
							<IconButton
								onClick={isInFavourites ? this.removeFromFavourites : this.addToFavourites}
								id={`docLibItem${index}FavouriteBtn`}
								disabled={loadingContent}
							>
								{isInFavourites
									? <Star fontSize="small" sx={{ color: '#ff9a00' }} />
									: <StarBorder fontSize="small" />}
							</IconButton>
						</Tooltip>
					</ListItemSecondaryAction>
				</ListItem>
				<Divider sx={{ m: 0 }} />
			</>
		);
	}
}

Folder.contextType = ContentContext;

export default Folder;
